import React from "react";

import { LANDING_MENU_BAR } from "../../constants/strings/StringsDashboard";

function GeoreferencingComponent(props) {
  return (
    <>
      <div className="container-general-inform">
        <div></div>
        <div className="div-titulo-informes text-center">
          {LANDING_MENU_BAR.STATISTICS_GEOREFERENCING}
        </div>
      </div>
      <div className="content-landing">
        <div className="center-content">
          <div id='map' style={{width:'100%', marginBottom:'20px'}}></div>
        </div>
      </div>
    </>
  );
}

export default GeoreferencingComponent;
